<template>
  <v-menu v-model="menu" nudge-bottom="12px" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small outlined color="#006c27" v-bind="attrs" v-on="on">
        <v-icon left small>mdi-shield-edit-outline</v-icon>
        Override
      </v-btn>
    </template>
    <v-card width="380">
      <v-card-title class="text--secondary text-subtitle-1">
        Global Portal Status Override
      </v-card-title>
      <v-card-text>
        <v-alert v-if="override && override.status" dense outlined type="warning">
          Effective status is forced to {{ override.status }} for all environments.
        </v-alert>
        <div v-if="override" class="text-caption mb-3">
          Current: {{ override.status || "clear" }}
          <span v-if="override.updatedBy"> by {{ override.updatedBy }}</span>
          <span v-if="override.updatedAt"> at {{ formatDate(override.updatedAt) }}</span>
        </div>
        <v-select
          v-model="selectedStatus"
          :items="statuses"
          label="Effective status"
          outlined
          dense
          color="#006c27"
        ></v-select>
        <v-textarea
          v-model="reason"
          label="Reason"
          outlined
          dense
          rows="2"
          counter="500"
          :rules="[value => !!(value && value.trim()) || 'Reason is required']"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :disabled="loading" @click="menu = false">Cancel</v-btn>
        <v-btn
          color="#006c27"
          dark
          :loading="loading"
          :disabled="!reason || !reason.trim()"
          @click="submit"
        >
          Apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import cass from "../api/cass";

export default {
  name: "SAPAPIStatusOverride",
  props: {
    override: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      menu: false,
      loading: false,
      selectedStatus: null,
      reason: "",
      statuses: [
        { text: "Clear override", value: null },
        { text: "ONLINE", value: "ONLINE" },
        { text: "OFFLINE", value: "OFFLINE" },
      ],
    };
  },
  watch: {
    menu(open) {
      if (open) {
        this.selectedStatus = this.override && this.override.status ? this.override.status : null;
        this.reason = "";
      }
    },
  },
  methods: {
    formatDate(value) {
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
    },
    async submit() {
      this.loading = true;
      try {
        const response = await cass.patchAdminSAPAPIStatusOverride(
          this.selectedStatus,
          this.reason
        );
        this.$emit("changed", response.data);
        this.menu = false;
      } catch (error) {
        this.$emit("error", cass.handleError(error).message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
